<div class="dialog-container">
  <div class="dialog-header pl-35 mt-20">
    <div class="dialog-header-title">
      {{ 'ORDER_DASHBOARD.PRINT_ORDERS' | fallbackTranslate }}
    </div>
    <div class="dialog-header-cross m-r-35" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <hr class="hr-line" />

  <div
    class="dialog-form pl-35 pr-35"
    *ngIf="!(order_status == 4 || order_status == 6)"
  >
    <div class="confirm-class">
      <div
        class="batch-card"
        *ngFor="
          let batch of ordersIteration | keyvalue : sortKeysAsNumbers;
          let i = index
        "
      >
        <div class="section-card">
          <label for="">
            {{ 'ORDER_DASHBOARD.BATCH' | fallbackTranslate }} {{ batch.key }}
          </label>
          <div style="display: flex; flex-wrap: wrap">
            <div
              class="batch-sections"
              *ngFor="let item of batch.value | keyvalue"
            >
              <p class="counter-name" for="">
                {{ getKitchenCounterName(item.key) }}
              </p>
              <div
                class="print"
                id="print_order"
                (click)="print(item.value, item.key, batch.key)"
              >
                {{ 'ORDER_DASHBOARD.PRINT' | fallbackTranslate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="pb-25"></div>
  <div class="print_button">
    <div class="print-final" (click)="printFinalBill()" *ngIf="!isKioskOrder">
      {{ 'ORDER_DASHBOARD.PRINT_FINAL_BILL' | fallbackTranslate }}
    </div>
    <div
      *ngIf="masterDocketEnabled()"
      class="print-final m-l-10"
      (click)="printMasterDocket()"
    >
      {{ 'ORDER_DASHBOARD.PRINT_MASTER_ORDER_LIST' | fallbackTranslate }}
    </div>
  </div>

  <div class="pb-25"></div>
</div>

<div id="table">
  <div class="border" style="padding: 4px" *ngIf="printData?.type == 'counter'">
    <!-- <div class="rest_details">
      <strong
        ><p>{{ restaurantName }}</p></strong
      >
      <p>{{ rest_address }}</p>
      <p class="bold">INVOICE</p>
    </div> -->
    <div style="text-align: center; margin-bottom: 20px; font-weight: 700">
      {{ printData?.counterName | titlecase }}
    </div>

    <div class="order_details">
      <p class="bold">Table: {{ printData?.body?.Table }}</p>
      <p style="margin-top: 20px">
        Invoice No:{{ printData?.body?.Invoice_No }}
      </p>
      <p>Date: {{ now | date : 'dd-MM-yyyy' }}</p>
      <p>Time: {{ now | date : 'hh:mm a' }}</p>
    </div>

    <table>
      <tbody>
        <tr>
          <th width="80%" align="left">Item Name</th>
          <th width="20%" align="left">QTY</th>
        </tr>
        <tr *ngFor="let item of printData.items; let i = index">
          <td width="80%" align="left">
            {{ item.name }}
            <div
              class="addons_variants_text"
              style="font-size: 9px !important"
              *ngIf="item.variant != ''"
            >
              Variants -
              <p>{{ item.variant }}</p>
            </div>
            <div
              class="addons_variants_text"
              style="font-size: 9px !important"
              *ngIf="item.addon != ''"
            >
              Addons -
              <p>{{ item.addon }}</p>
            </div>
          </td>
          <td width="20%" align="left">{{ item.qty }}</td>
        </tr>
      </tbody>
    </table>
    <hr class="hr-line" />

    <div
      class="allergy"
      style="text-align: center"
      *ngIf="printData?.allergic_items.length > 0"
    >
      Allergies:-
      <span *ngFor="let item of printData?.allergic_items">{{ item }} </span>

      <hr class="hr-line" />
    </div>
    <div
      class="allergy"
      style="text-align: center"
      *ngIf="printData?.note.length > 0"
    >
      Notes:- <span *ngFor="let item of printData?.note">{{ item }} </span>

      <hr class="hr-line" />
    </div>

    <div
      class="thank"
      style="text-align: center; margin-bottom: 20px; font-weight: 700"
    >
      Thank You
    </div>
  </div>
</div>

<div id="finalBill">
  <div class="border" style="padding: 4px" *ngIf="printData?.type == 'receipt'">
    <div class="rest_details">
      <strong *ngFor="let item of printData?.header">
        <p>{{ item }}</p>
      </strong>
      <!-- <p>{{ rest_address }}</p> -->
      <p class="bold">INVOICE</p>
    </div>
    <div class="order_details">
      <p>
        Table: <span class="bold">{{ printData?.body?.Table }}</span>
      </p>
      <p>Invoice No: {{ printData?.body?.Invoice_No }}</p>
      <p>Date: {{ printData?.body?.Date }}</p>
      <p *ngIf="printData?.body?.Cashier != ''">
        Cashier: {{ printData?.body?.Cashier }}
      </p>
    </div>

    <table>
      <tbody>
        <tr>
          <th width="50%" align="left">Items</th>
          <th width="20%" align="left">Price</th>
          <th width="10%" align="left">Qty</th>
          <th width="20%" align="left">Amt</th>
          <th></th>
        </tr>

        <tr *ngFor="let item of printData?.order?.items; let i = index">
          <td width="50%" align="left">
            {{ item.name }}
            <div
              class="addons_variants_text"
              style="font-size: 9px !important"
              *ngIf="item.variant != ''"
            >
              Variants -
              <p>{{ item.variant }}</p>
            </div>
            <div
              class="addons_variants_text"
              style="font-size: 9px !important"
              *ngIf="item.addon != ''"
            >
              Addons -
              <p>{{ item.addon }}</p>
            </div>
          </td>
          <td width="20%" align="left">
            {{ item.price }}
          </td>
          <td width="10%" align="left">{{ item.qty }}</td>
          <td width="20%" align="left">{{ item.amount }}</td>
        </tr>
      </tbody>
    </table>
    <hr class="hr-line" />

    <!-- <div class="fee" style="width: 100%; display: flex;">
      <div class="fee-left"  style="width: 50%;">
        <div style="padding:2px 0px" *ngFor="let item of printData?.order?.bill">
          {{item.name}}
        </div>
      </div>
      <div class="fee-right" style="width: 50%;">
        <div  style="padding:2px 0px" *ngFor="let item of printData?.order?.bill">
          <span *ngIf="isNumber(item.value)">{{printData?.order?.currency}} {{item.value}}</span>
          <span *ngIf="!isNumber(item.value)">{{item.value}}</span>
        </div>
      </div>
    </div> -->
    <table>
      <tbody>
        <tr *ngFor="let item of printData?.order?.bill">
          <td width="50%" align="left" style="font-size: 12px">
            {{ item.name }}
          </td>
          <td width="50%" align="left" style="font-size: 12px">
            <span *ngIf="isNumber(item.value)"
              >{{ printData?.order?.currency }} {{ item.value }}</span
            >
            <span *ngIf="!isNumber(item.value)">{{ item.value }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <hr class="hr-line" />

    <div
      class="thank"
      style="text-align: center; margin-bottom: 20px; font-weight: 700"
    >
      Thank You
    </div>
  </div>
</div>
